
import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import App from './App.tsx'
import './index.css'
import NotFound from './pages/NotFound.tsx'
import { LoadingScreen } from '@/components/ui/LoadingScreen'

// Add a global style for the initial loading state
const style = document.createElement('style')
style.innerHTML = `
  .app-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }
  
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border-left: 4px solid #3b82f6;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .fade-out {
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }
`
document.head.appendChild(style)

// Create initial loading indicator
const loadingPlaceholder = document.createElement('div')
loadingPlaceholder.className = 'app-loading'
loadingPlaceholder.innerHTML = '<div class="spinner"></div>'
document.body.appendChild(loadingPlaceholder)

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <div className="bg-white min-h-screen">
      <App />
    </div>
  </StrictMode>
);

// Remove the loading placeholder after the app has loaded
window.addEventListener('load', () => {
  setTimeout(() => {
    const loadingElement = document.querySelector('.app-loading');
    if (loadingElement) {
      loadingElement.classList.add('fade-out');
      setTimeout(() => {
        if (loadingElement.parentNode) {
          loadingElement.parentNode.removeChild(loadingElement);
        }
      }, 500);
    }
  }, 300);
});
